import * as React from 'react'
import '../../css/page/dropdown.css'

export class DropdownItem extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return <div className={"dropdown-item"} onClick={() => {
      this.props.onClick && this.props.onClick()
    }}>
      {this.props.children}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdown/item.js